export default () => ({
    textTitle: 'Madec'
})